import React from 'react';
import Award from '../../../components/ui/award/Award';

const Awards =(props)=> {
    return (
        <Award ></Award>
        );
}
export default Awards;